import { render } from "./HeaderChallengeResults.vue?vue&type=template&id=1b5fe6a8&scoped=true"
import script from "./HeaderChallengeResults.vue?vue&type=script&lang=js"
export * from "./HeaderChallengeResults.vue?vue&type=script&lang=js"

import "@/css/components/header-challenge-results.css?vue&type=style&index=0&id=1b5fe6a8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5fe6a8"]])

export default __exports__